import {
  LOGOUT,
  RESET_UNSEEN_MESSAGE_COUNT,
  SET_CHAT_RECEIVER_DETAILS,
  SET_JOB_MEMBERS_PROFILE,
  SET_UNSEEN_MESSAGE_COUNT,
} from "../actions/action.types";

const initialState = {
  unseenCount: 0,
  membersProfile: [],
  chatReceiverDetails: null,
};

const messageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_UNSEEN_MESSAGE_COUNT:
      return {
        ...state,
        unseenCount: action.payload,
      };
    case SET_JOB_MEMBERS_PROFILE:
      return {
        ...state,
        membersProfile: action.payload,
      };
    case SET_CHAT_RECEIVER_DETAILS:
      return {
        ...state,
        chatReceiverDetails: action.payload,
      };
    case RESET_UNSEEN_MESSAGE_COUNT:
      return {
        ...state,
        unseenCount: 0,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default messageReducer;
